import { api } from '@/services'
export function fetchAnnouncements(params) {
    return api.get('/admin/announcement/list', { params: params }) 
}
export function fetchAnnouncement(id) {
    return api.get(`/admin/announcement/show/${id}`) 
}
export function deleteAnnouncement(id) {
    return api.delete(`/admin/announcement/${id}`) 
}
export function create(body) {
    return api.post('/admin/announcement/create', body)
}